/*
 * Copyright (C) 2026 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {
  handleOneTrustGroupsUpdated,
  reconcileFunctionalCookies,
  setFunctionalCookie,
} from '@canvas/cookies'

declare global {
  interface Window {
    // Bridge for code that can't import @canvas/cookies directly — e.g.
    // packages/ (jqueryui tabs), which the no-packages-to-ui layering rule
    // forbids from importing ui/ modules.
    CANVAS_FUNCTIONAL_COOKIES?: {set: typeof setFunctionalCookie}
  }
}

// Registered on every page so functional cookies queued via setFunctionalCookie
// get flushed when consent is granted, and cleared when consent is revoked.
// Also publishes the consent-gated setter on window so packages/ code can reach
// it without importing ui/ (see the no-packages-to-ui dependency-cruiser rule).
export function up(): void {
  window.CANVAS_FUNCTIONAL_COOKIES = {set: setFunctionalCookie}
  window.addEventListener('OneTrustGroupsUpdated', ((e: CustomEvent<string[] | string>) => {
    handleOneTrustGroupsUpdated(e.detail)
  }) as EventListener)
  // Catches a consent decision that landed before this bundle loaded.
  reconcileFunctionalCookies()
}
